import { Box } from '@bechtel/gds';
// import { map } from 'lodash';
// import { drawingList } from './mock';
// import { DrawingItemStyled } from './styled';
import { UnderConstruction } from '~/components';

export const Drawings = () => {
  return (
    <Box pt={{ sm: '500' }} flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
      <Box flexGrow={{ sm: ' 1' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }}>
        <UnderConstruction />
      </Box>
      {/* {map(drawingList, (item) => (
        <DrawingItemStyled key={item.id}>
          <Box mb={{ sm: '200' }}>
            <Text size="300" color="grey.600" family="openSansCondensed">
              {item.type}
            </Text>
          </Box>
          <Text size="400" color="black" weight="500" family="openSansCondensed">
            {item.name}
          </Text>
        </DrawingItemStyled>
      ))} */}
    </Box>
  );
};
